import { GREY_CHATEAU } from "../../../constants/colors";

const borderColor = { default: `${GREY_CHATEAU}` };
const borderSize = { default: "1px" };
export const fallbackValues = {
  borderColor,
  borderSize
};
